import React from 'react';
import { ThemeProvider } from './contexts/ThemeContext';
import { NavigationProvider, useNavigation } from './contexts/NavigationContext';
import Header from './components/Header/Header';
import Home from './pages/Home/Home';
import AboutUs from './pages/AboutUs/AboutUs';
import Activities from './pages/Activities/Activities';
import Publishings from './pages/Publishings/Publishings';
import Sanad from './pages/Sanad/Sanad';
import Applications from './pages/Applications/Applications';
import Podcasts from './pages/Podcasts/Podcasts';
import Academia from './pages/Academia/Academia';
import Womens from './pages/Womens/Womens';
import patternSvg from './assets/imgs/us/pattern/1.svg';
import './App.css';

const AppContent = () => {
  const { currentPage } = useNavigation();

  const renderPage = () => {
    switch (currentPage) {
      case 'about':
        return <AboutUs />;
      case 'activities':
        return <Activities />;
      case 'publishings':
        return <Publishings />;
      case 'academia':
        return <Academia />;
      case 'sanad':
        return <Sanad />;
      case 'applications':
        return <Applications />;
      case 'womens':
        return <Womens />;
      case 'podcasts':
        return <Podcasts />;
      case 'home':
      default:
        return <Home />;
    }
  };

  return (
    <div className="App" style={{ '--pattern-image': `url(${patternSvg})` }}>
      <Header />
      {renderPage()}
    </div>
  );
};

function App() {
  return (
    <ThemeProvider>
      <NavigationProvider>
        <AppContent />
      </NavigationProvider>
    </ThemeProvider>
  );
}

export default App;
